<template>
  <div
    class="section"
    :class="backgroundClass"
  >
    <div
      class="medium-page mx-auto d-flex justify-space-between align-center white--text px-6 px-md-0"
    >
      <router-link
        to="/"
        class="d-flex align-center"
      >
        <v-img
          v-vue-aos.once="{ animationClass:'fadeInLeft slow animated' }"
          contain
          width="56"
          height="56"
          src="/img/icon-primary-white.svg"
        />
      </router-link>

      <div
        class="nav-links d-md-flex d-none align-center justify-end text-subtitle-1"
      >
        <router-link
          to="/"
          class="mr-8"
          v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
        >
          Home
        </router-link>

        <v-menu
          bottom
          offset-y
          open-on-hover
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <a
              href="#"
              class="mr-8"
              v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
              v-bind="attrs"
              v-on="on"
            >
              Products
            </a>
          </template>

          <v-list
            dense
            class="mt-3 list-items"
          >
            <v-hover
              v-for="(item, index) in products"
              :key="'product-' + index"
              v-slot="{ hover }"
            >
              <v-list-item
                @click="$router.push(item.to)"
                :class="hover ? 'primary' : null"
                :dark="hover"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon
                    small
                    :color="hover ? 'white' : 'black'"
                  >
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title :class="{ 'white--text': hover }">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list>
        </v-menu>

        <a
          href="/#about"
          class="mr-8"
          v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
        >
          About Us
        </a>

        <a
          href="/#contact"
          class="mr-8"
          v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
        >
          Contact Us
        </a>

        <!-- <a
          href="#"
          class="mr-8"
          v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
        >
          Services
        </a> -->

        <v-btn
          depressed
          class="primary white--text"
          :to="{ name: 'Login' }"
          v-vue-aos.once="{ animationClass:'fadeInRight slow animated' }"
        >
          Login
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: 'NavigationBar',

  // Define local data variables
  data: () => ({
    // The background class for the container
    backgroundClass: "py-4",

    // The dropdown links for the products option
    products: [
      {
        text: "Influencer Discovery",
        icon: "person_search",
        to: {
          name: "Product/InfluencerDiscovery"
        }
      },

      {
        text: "Influencer Insight",
        icon: "insights",
        to: {
          name: "Product/InfluencerInsight"
        }
      },

      {
        text: "Audience Overlap",
        icon: "picture_in_picture",
        to: {
          name: "Product/AudienceOverlap"
        }
      },

      {
        text: "Tie Breaker",
        icon: "compare",
        to: {
          name: "Product/TieBreaker"
        }
      },

      {
        text: "Paid Collaborations",
        icon: "query_stats",
        to: {
          name: "Product/PaidCollaborations"
        }
      },

      {
        text: "CRM",
        icon: "support_agent",
        to: {
          name: "Product/CRM"
        }
      },
    ]
  }),

  // THe local method functions
  methods: {
    /**
     * When the user scrolls the page, update the background of the navigation
     *
     * @returns {void}
     */
    handleScroll() {
      // Check if the scroll distance is not 0
      if (window.pageYOffset !== 0) {
        this.backgroundClass = "bluegray darken-1 py-2"
      }
      else {
        this.backgroundClass = "py-4"
      }
    }
  },

  /**
   * As soon as the component is created
   *
   * @returns {void}
   */
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },

  /**
   * Just before the component is going to be un-rendered
   *
   * @returns {void}
   */
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll)
  }
}
</script>

<style lang="stylus" scoped>
.section
  position fixed
  top 0
  left 0
  width 100%
  z-index 100000
  transition 0.2s linear all

.nav-links a
  text-decoration none
  color white
</style>
